import { AsyncLoaderTemplate } from '@shared/Frontend/asyncLoader'
import { AsyncState, Maybe, Template, Unit, unit } from 'ballerina-core'
import React, { ReactNode, useEffect } from 'react'
import { getTeasers } from './teasers.api'
import { Teaser, TeaserKind, Teasers, TeasersAsync } from './teasers.state'
import { FiltersMap, FiltersState } from '../filters/filters.state'
import { fieldUpdater } from '@shared/Frontend/utils/updaters'

export type TeasersContext = {
  type: TeaserKind
  page: number
  slug: string
  filters: FiltersState
}
export type TeaserState = {
  items: TeasersAsync
}
export type TeasersView = {
  Loader: (_: { type?: 'inline' | 'full' }) => ReactNode
  Teasers: (_: { type: TeaserKind; page: number; totalPages: number; items: Teaser[] }) => ReactNode
}

export const TeasersTemplate = Template.Default<TeasersContext, TeaserState, Unit, TeasersView>(
  ({ context, setState, view }) => {
    useEffect(() => {
      const loading = (s0: TeaserState) => AsyncState.Updaters.toLoading<Maybe<Teasers>>()(s0.items)
      setState(s0 => ({
        ...s0, items: loading(s0)
      }))
    }, [window.location.search])
    if (!AsyncState.Operations.hasValue(context.filters)) return <view.Loader type='inline' />
    if (!context.filters.value) return <view.Loader type='inline' />

    const filters = context.filters.value

    return <>
      {AsyncState.Operations.hasValue(context.filters) && context.filters.value &&
        <TeasersLoaderTemplate
          context={{
            ...context.items,
            promise: () =>
              getTeasers({
                type: context.type,
                page: context.page,
                slug: context.slug,
                filters,
              }),
          }}
          setState={updater => setState(s0 => fieldUpdater<TeaserState>()("items")(updater)(s0))}
          foreignMutations={unit}
          view={unit}
        />
      }
      {AsyncState.Operations.hasValue(context.items) && context.items.value ? (
        <view.Teasers
          type={context.type}
          page={context.page}
          totalPages={context.items.value.totalPages}
          items={context.items.value.items}
        />
      ) : (
        <view.Loader type="inline" />
      )}
    </>
  }
)

const TeasersLoaderTemplate = AsyncLoaderTemplate<Maybe<Teasers>>()
